"use strict";

export function createLastUpdateEventMap() {
  return {
    value: new Map()
  };
}
//# sourceMappingURL=lastUpdateEventMap.web.js.map